import { render } from "./FiltrosModal.vue?vue&type=template&id=53805666&scoped=true"
import script from "./FiltrosModal.vue?vue&type=script&lang=js"
export * from "./FiltrosModal.vue?vue&type=script&lang=js"

import "./FiltrosModal.vue?vue&type=style&index=0&id=53805666&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53805666"]])

export default __exports__